"use client";
import React, { useRef, useEffect, useState, useMemo } from "react";
import { Path, Layer, Group } from "react-konva";
import useSeatmapStore from "../../../../../../../../stores/seatmapStore";
import { useTooltips } from "../../providers/TooltipProvider";

const Sections = React.memo(
  ({ data }) => {
    const sectionLookupTable = useSeatmapStore(
      (state) => state.sectionLookupTable
    );
    return (
      <Layer>
        {data?.sections &&
          Object.values(data.sections).map((section) => {
            if (section?.zoomable) return;
            return (
              <GASection
                key={section?.sectionId}
                section={section}
                // handleSectionSelect={handleSectionSelect}
                sectionLookupTable={sectionLookupTable}
              />
            );
          })}
      </Layer>
    );
  }
);

function GASection({ section, sectionLookupTable }) {
  const visualRef = useRef(null);
  const pathRef = useRef(null);
  const { showTooltip } = useTooltips();

  const handleSectionSelect = (e, section) => {
    const stage = e.target.getStage();
    const pointerPos = stage.getPointerPosition();
    showTooltip(section.sectionId, pointerPos.x, pointerPos.y);
  };

  const sectionSoldout = (sectionId) => {
    const section = sectionLookupTable[sectionId];
    if (sectionId === "805c2485-eb97-415b-b19d-0830fc798ce2") {
      console.log("section: ", section);
    }
    return !section;
  };

  const UNAVAILABLE_COLOR = "#E6E8EC";
  const sectionFill = sectionSoldout(section.sectionId) ? UNAVAILABLE_COLOR : section.fill;

  return (
    <Group
     onClick={(e) => handleSectionSelect(e, section)}
     onTap={(e) => handleSectionSelect(e, section)}
      listening={Boolean(sectionLookupTable[section.sectionId])}
      onMouseEnter={(e) => {
        const container = e.target.getStage().container();
        container.style.cursor = "pointer";
      }}
      onMouseLeave={(e) => {
        const container = e.target.getStage().container();
        container.style.cursor = "default";
      }}
    >
      {/* Section with color based on inventory */}
      <Path
        fill={sectionFill}
        ref={pathRef}
        data={section.path}
        className='path'
        listening={true}
        transformsEnabled='position'
        perfectDrawEnabled={false}
        stroke={section?.stroke}
        strokeWidth={Number(section?.strokeWidth) || 0}
        shadowForStrokeEnabled={false}
        id={section.sectionId}
      />

      {/* Section identifier */}
      <Path
        ref={visualRef}
        data={section?.identifier?.path}
        fill='white'
        listening={false}
      />
    </Group>
  );
}

export { Sections };
